import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Container, Typography } from "@material-ui/core";
import TableSelector from "./tables/TableSelector";
import AuthForm from "./AuthForm";
import { cyrb53 } from "../tools/cybr54";

/**
 * The styles for the React component.
 */
const useStyles = makeStyles((theme) => {
  return {
    mainTitle: {
      fontFamily: "Montserrat-Black",
    },
    content: {
      marginTop: 30,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
  };
});

/**
 * This is the dashboard page.
 * */
function DashboardPage(props) {
  const classes = useStyles();

  if (
    String(localStorage.getItem("secret")) ===
    String(cyrb53(process.env.REACT_APP_SECRET))
  )
    return (
      <Container className={classes.content}>
        <Grid
          container
          direction={"column"}
          justify={"center"}
          alignItems={"center"}
          spacing={5}
        >
          <Grid item>
            <img
              src={"/images/nirvana-logo.png"}
              style={{
                width: 150,
                objectFit: "contain",
              }}
            />
            <Typography variant={"overline"}> Admin</Typography>
          </Grid>
          <Grid item>
            <TableSelector />
          </Grid>
        </Grid>
      </Container>
    );
  else return <AuthForm />;
}

// Gets props from the redux store
const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/DashboardPage.js